import { useState, useEffect } from "react";

const Timer = ({ onTimerExpire, timeInSec }) => {
  const [remainingTime, setRemainingTime] = useState(timeInSec); //900sec 15 minutes in seconds

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime === 0) {
          clearInterval(timer);
          // Perform necessary actions when timer reaches zero
          onTimerExpire();
          return 0;
        } else {
          return prevTime - 1;
        }
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  return formatTime(remainingTime);
};

export default Timer;
